<template>
  <div>

    <div class="col-12 mb-2 d-flex justify-content-end">
      <div>
        <button class="btn btn-success float-right"
          id="popover-reactive-1"
          ref="button"      
          :disabled="popoverShow">
            <feather-icon
              icon="DownloadIcon"
              class="mr-50"
            />
          <span class="align-middle">{{ popoverShow ? 'Dosya Hazırlanıyor...' : 'Excel Hazırla' }}</span>    
        </button>

        <b-popover
          ref="popover"
          target="popover-reactive-1"
          triggers="click"
          :show.sync="popoverShow"
          placement="auto"
          container="my-container"
        >
        <template #title>
          <div class="d-flex justify-content-between align-items-center">
            <span>Excel Hazırla</span>
          </div>
        </template>
          <link-dowload-excel :excelTitle="'Feonmen'" :rangeDateProps="rangeDateProps" v-model="popoverShow" @popoverShow="popoverShow = $event" />
          
        </b-popover>
      </div>
    </div>

    <analysis-header :totalAmount="totalAmount" ref="analysisHeader" title="Fenomen/Satış Analizi" @update-range="updateRange"></analysis-header>
    
  
    <b-card-title class="text-danger mt-2" v-if="loadChart && dataList.length==0">Seçilen tarihler arasında kayıt bulunamadı</b-card-title>

    <b-row class="match-height" v-show="dataList.length>0">
      <!-- Sipariş Tutarları Grafiği -->
      <b-col md="12" >
        <chartjs-horizontal-bar-chart :chartData="chartDataHorizontal" @select-row="selectRow" :loadChart="loadChart" :totalAmount="totalAmount" :hasParcent="true"/>

        <!-- Row Detail -->
        <div class="position-fixed bg-light" @click="detailPopup=!detailPopup" v-if="detailPopup" style="inset: 0px; opacity: 0.85; backdrop-filter: blur(2px);"></div>
        <b-col md="10" class="position-absolute row-detail-popup" v-if="detailPopup">
          <b-card>
          <b-card-title class="mb-1 d-flex justify-content-between w-100">
            <div>
              <influencer-link-btn :id="selectedData.id" :name="selectedData.username" class="mr-5px"/>
            </div>
            <div>
              {{ selectedData.total_count }} Adet / {{ priceFormat(selectedData.total_amount) }}
            </div>
            <feather-icon icon="XIcon" class="cursor-pointer" size="22" @click="detailPopup=false"  />
          </b-card-title>

          <b-card-sub-title class="mb-2">
            <b class="text-primary"> {{ formatDate(getRangeDate[0])}} - {{ formatDate(getRangeDate[1]) }}</b> Sipariş Detayları
          </b-card-sub-title>
          
          <div class="row">
            <b-col md="9">
              <!-- Sipariş Datası sağda açılacak -->
              <link-analysis :infId="selectedData.id" :dateRange="getRangeDate"/>
            </b-col>
            <b-col md="3">
              <!-- Sipariş Datası sağda açılacak -->
              <apex-donut-chart :chartData="apexData" />
            </b-col>
          
          </div>
          </b-card>
        </b-col>
        <!-- Row Detail End -->

      </b-col>
    </b-row>    
    <app-echart-bar class="w-100 d-none"
      ref="bar-chart"
      :option-data="option"
    />

      <b-card title="Satışı bulunmayan Fenomenler" class="mt-2" v-if="zeroData.length>0">
        <b-table-lite
          ref="refUserListTable"
          :items="zeroData"
          responsive
          primary-key="id"
          show-empty
          empty-text="No matching records found"
        >
          <template #cell(name_surname)="data">
            <influencer-link-btn :id="data.item.id" :name="data.item.name_surname" class="mr-5px"/>
          </template>
        </b-table-lite>
      </b-card>
  </div>
</template>
  
  <script>
  import ChartjsHorizontalBarChart from './ChartjsHorizontalInfluencer.vue'
  import AnalysisHeader from './AnalysisHeader.vue'
  import { BRow, BCol, BCard, BCardHeader, BButton, BCardSubTitle, BCardTitle, BTableLite, BPopover } from 'bootstrap-vue'
  import vSelect from 'vue-select';
  import AppEchartBar from '@core/components/charts/echart/AppEchartBar.vue'
  import ApexDonutChart from '@core/components/charts/apex/ApexDonutChart.vue'
  import linkAnalysis from '../analysis/Links.vue'
  import InfluencerLinkBtn from '@/components/link/InfluencerLinkBtn.vue';
  import LinkDowloadExcel from '@/components/link/LinkDowloadExcel.vue'; 
  
  export default {
    components: {
      BRow,
      BCol,
      BCard,
      BButton,
      BCardHeader,
      BCardSubTitle,
      BCardTitle,
      BTableLite,
      BPopover,

      ChartjsHorizontalBarChart,
      AnalysisHeader,
      AppEchartBar,
      ApexDonutChart,
      linkAnalysis,
      InfluencerLinkBtn,
      vSelect,
      LinkDowloadExcel
    },
    data() {
      return {  
        detailPopup:false,
        popoverShow: false,
        chartData: {
          labels: [],
          datasets: [
            {
              data: [],
              backgroundColor:  '#28dac6',
              borderColor: 'transparent',
              barThickness: 15
            },
          ],
        },
        dataList:[],
        chartDataHorizontal: {},
        apexData:{
          labels:['Teslim Edildi','İptal Edildi','Ödeme Bekleniyor','Onaylandı','Ürün Hazırlanıyor','Kapıda Ödeme Teyit Bekleniyor']
        }, //apex detail için...
        loadChart:false,
        selectedData:{},
        zeroData:[],
        rangeDateProps:{},  
        option: {
          xAxis: [
            {
              type: 'value',
            },
          ],
          yAxis: [
            {
              type: 'category',
              data: [],
              splitLine: { show: false },
            },
          ],
          grid: {
            left: '200px',
            right: '30px',
            bottom: '30px',
          },
          series: [
            {
              name: 'Teslim Edildi',
              type: 'bar',
              stack: 'advertising',
              data: [],
              barWidth: '30%',
            },
            {
              name: 'İptal Edildi',
              type: 'bar',
              stack: 'advertising',
              data: [],
              barWidth: '30%',
            },
            {
              name: 'Ödeme Bekleniyor',
              type: 'bar',
              stack: 'advertising',
              data: [],
              barWidth: '30%',
            },
            {
              name: 'Onaylandı',
              type: 'bar',
              stack: 'advertising',
              data: [],
              barWidth: '30%',
            },
          ],
        },
      }
    },
    created () {
      // İlk yüklemede rangeDate bu ay bilgilerini al
      const today = new Date();
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const rangeDate = [this.changeFormat(firstDayOfMonth), this.changeFormat(today)];
      this.rangeDateProps = {
        start_date: rangeDate[0],
        end_date: rangeDate[1]  
      }
      this.getData(rangeDate[0], rangeDate[1]);
    },
    methods: {
      updateRange(range){
        // Tarihleri API'ye gönder
        this.rangeDateProps = {
          start_date: range[0],
          end_date: range[1]  
        }
        this.getData(range[0], range[1]);
      },
      getData(startDate=null,endDate=null) {
        this.$http.get('/analysis/influencer', { params: { start_date: startDate, end_date: endDate } }).then((response) => {
          // Dönen fenomen listesini al
          const data = response.data.data.hasOrder;

          this.zeroData = response.data.data.noOrder;

          // Fenomenleri total_amount değerine göre azalan sırayla sıralayın
          this.dataList = data.sort((a, b) => b.total_amount - a.total_amount);

          // Grafikleri güncelle
          this.updateChartData();     


          this.option.yAxis[0].data = this.dataList.map((item)=>{
            const value = item.total_amount; // Veri değeri
            const percentage = (value / this.totalAmount * 100).toFixed(2); // Yüzde hesaplama
            return `${item.name_surname} - %${percentage}`; // dinamik etiket formatı
          })          

          this.updateChartDataNew();

        }).catch((error) => {
          console.error('Veri alımı sırasında bir hata oluştu:', error);
        });
      },
      updateChartData(){
        this.loadChart=false;
        
        const labels = this.dataList.map((item)=>{
          return item.name_surname
        })
        const dataAmount = this.dataList.map((item)=>{
          return [item.total_count, item.total_amount]
        })

        this.chartDataHorizontal = JSON.parse(JSON.stringify(this.chartData));
        this.chartDataHorizontal.labels = [...labels];
        this.chartDataHorizontal.datasets[0].data = [...dataAmount]; // Burada döngüsel yapı olmamalı

        setTimeout(() => {
          this.loadChart=true 
        }, 500);
      },
      selectRow(data) {
        this.detailPopup = true; // Popup'u göster
        
        // Seçilen fenomeni al
        this.selectedData = this.dataList[data];

        // Status sayımlarını başlat
        const counts = { delivered: 0, cancelled: 0, pending: 0, approved: 0, ready_product:0, waitingPay:0 };

        // Siparişleri statuslere göre analiz et
        if (this.selectedData.orders && this.selectedData.orders.length > 0) {
          this.selectedData.orders.forEach((order) => {
            switch (order.order_status_id) {
              case 8:
                counts.delivered++;
                break; // Teslim Edildi
              case 9:
                counts.cancelled++;
                break; // İptal Edildi
              case 2:
                counts.pending++;
                break; // Ödeme Bekleniyor
              case 3:
                counts.ready_product++;
                break; // Ürün Hazırlanıyor
              case 12:
                counts.approved++;
                break; // Onaylandı
              case 4:
                counts.waitingPay++;
                break; // Kapıda ödeme bekleniyor
              default:
                break;
            }
          });
        }

        // Toplam sipariş sayısını hesapla
        const totalOrders =
          counts.delivered + counts.cancelled + counts.pending + counts.approved + counts.approved + counts.waitingPay;

        // Oranları hesapla
        const percentages = totalOrders
          ? {
              delivered: (counts.delivered / totalOrders) * 100,
              cancelled: (counts.cancelled / totalOrders) * 100,
              pending: (counts.pending / totalOrders) * 100,
              ready_product: (counts.ready_product / totalOrders) * 100,
              approved: (counts.approved / totalOrders) * 100,
              waitingPay: (counts.waitingPay / totalOrders) * 100,
            }
          : { delivered: 0, cancelled: 0, pending: 0, approved: 0,ready_product:0, waitingPay:0 };
        

        // `apexData`'yı güncelle
        this.apexData = {
          ...this.apexData, // Mevcut `apexData` içeriğini kopyala
          detail: { ...this.selectedData }, // Detay bilgisini ekle
          series: [
            parseFloat(percentages.delivered.toFixed(2)), // Float değer olarak ekle
            parseFloat(percentages.cancelled.toFixed(2)),
            parseFloat(percentages.pending.toFixed(2)),
            parseFloat(percentages.approved.toFixed(2)),
            parseFloat(percentages.ready_product.toFixed(2)),
            parseFloat(percentages.waitingPay.toFixed(2)),
          ],
          counts: [
            counts.delivered,
            counts.cancelled,
            counts.pending,
            counts.approved,
            counts.ready_product,
            counts.waitingPay
          ], // Adetleri ayrı bir dizi olarak sakla
        };
      },


      updateChartDataNew() {

        // Her fenomenin order_status_id'sine göre siparişlerini analiz et
        const statusCounts = this.dataList.map((item) => {
          // orders içinde statuslere göre gruplama
          const counts = { delivered: '0', cancelled: 0, pending: 0, approved: 0 };
          
          console.log(item.orders.length)
          if(item.orders.length>0){
            item.orders.forEach((order) => {
              switch (order.order_status_id) {
                case 9: counts.delivered++; break; // Teslim Edildi
                case 8: counts.cancelled++; break; // İptal Edildi
                case 2: counts.pending++; break;   // Ödeme Bekleniyor
                case 5: counts.approved++; break;  // Onaylandı
                default: break;
              }
            });
          }

          return counts;
        });

        // `series` için dataları güncelle
        this.option.series[0].data = statusCounts.map(count => count.delivered);
        this.option.series[1].data = statusCounts.map(count => count.cancelled);
        this.option.series[2].data = statusCounts.map(count => count.pending);
        this.option.series[3].data = statusCounts.map(count => count.approved);

      }
    },
    computed: {
      totalAmount() {
        return this.dataList.reduce((total, item) => total + parseFloat(item.total_amount), 0);
      },
      
      getRangeDate() {
        return this.$refs.analysisHeader.rangeDate;
      },
    },
    watch: {
    },
  }
  </script>
  
  <style>
  
  .row-detail-popup{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  </style>